<div class="detail-page">
  <h1 class="page-title">My company</h1>

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else {
    <app-error-banner [message]="errorMessage()" />

    @if (company(); as c) {
      <div class="detail-header">
        <div class="detail-header__top">
          <h2>{{ c.name }}</h2>
          <app-status-badge [status]="c.status" />
        </div>

        <div class="info-grid">
          <div class="info-item">
            <span class="label">Registration No.</span>
            <span class="value">{{ c.registrationNo }}</span>
          </div>
          <div class="info-item">
            <span class="label">Country</span>
            <span class="value">{{ c.countryCode }}</span>
          </div>
          <div class="info-item">
            <span class="label">Contact email</span>
            <span class="value">{{ c.contactEmail }}</span>
          </div>
          <div class="info-item">
            <span class="label">Contact phone</span>
            <span class="value">{{ c.contactPhone || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Address</span>
            <span class="value">{{ c.address || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Registered</span>
            <span class="value">{{ c.createdAt | date: 'medium' }}</span>
          </div>
          @if (c.approvedAt) {
            <div class="info-item">
              <span class="label">Approved</span>
              <span class="value">{{ c.approvedAt | date: 'medium' }}</span>
            </div>
          }
          @if (c.rejectionReason) {
            <div class="info-item">
              <span class="label">Rejection reason</span>
              <span class="value">{{ c.rejectionReason }}</span>
            </div>
          }
          @if (c.suspensionReason) {
            <div class="info-item">
              <span class="label">Suspension reason</span>
              <span class="value">{{ c.suspensionReason }}</span>
            </div>
          }
        </div>
      </div>
    }
  }
</div>
